<script setup lang="ts">
import { useModalStore } from "@/stores/modals/modals.store";

import Button from "@/components/Reusables/Buttons/Button.vue";

const modals = useModalStore();

const handleCancel = () => {
  modals.close({ action: "cancel" });
};

const handleConfirm = async () => {
  modals.close({ action: "confirm" });
};
</script>

<template>
  <div class="space-y-px-24 flex flex-col">
    <h4 class="t-h4 text-type-default">Discard changes?</h4>
    <span>You have unsaved changes. Leaving this page will discard them.</span>

    <div class="flex justify-between">
      <Button
        label="Cancel"
        color="button"
        @click="handleCancel" />

      <Button
        label="Confirm"
        color="destructive"
        @click="handleConfirm" />
    </div>
  </div>
</template>
